import axios, { AxiosInstance } from "axios";
import { store } from "static";
import { DOMAIN } from "config/config";
import { DATA_LINK } from "./datalink";

export class BackendConnector {
  instance: AxiosInstance;
  constructor() {
    this.instance = axios.create({
      baseURL: DOMAIN,
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  post = async <T = any>(url: DATA_LINK, data?: any, addOns?: Object) => {
    interface IBackendResponse {
      Success: boolean;
      Message: string;
      payload: T;
    }
    const response = await this.instance.post<IBackendResponse>(url, {
      JWT: store.user.JWT,
      data: data,
      addOns: addOns,
    });
    return response.data;
  };

  get = async (url: DATA_LINK, data?: any) => {
    const response = await this.instance.get(url, data);
    return response.data;
  };

  upload = async <T = any>(url: DATA_LINK, file: File, addOns?: Object) => {
    let payloadOut = {
      data: {
        upload: file,
      },
      schema: [],
      replace: false,
      JWT: store.user.JWT,
      addOns: addOns || {},
    };

    let upload = new FormData();
    upload.append("data", JSON.stringify(payloadOut.data || {}));
    upload.append("schema", JSON.stringify(payloadOut.schema || {}));
    upload.append("addOns", JSON.stringify(payloadOut.addOns || {}));
    upload.append("replace", JSON.stringify(payloadOut.replace || {}));
    upload.append("JWT", store.user.JWT || "");
    if (payloadOut.data.upload) {
      upload.append("upload", payloadOut.data.upload, payloadOut.data.upload.name);
    }
    interface IBackendResponse {
      Success: boolean;
      Message: string;
      payload: T;
    }
    const response = await this.instance.post<IBackendResponse>(url, upload);
    return response.data;
  };
}

export const backendConnector = new BackendConnector();
